module.exports = __webpack_public_path__ + "static/media/result-page-arrow.52573655.png";